import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { secondsToReadable, secondsToReadablePrecise } from '@shared/utils/date-time';
import { isPresent } from '@shared/utils/helpers';

@Pipe({ name: 'appDurationPrecise' })
export class DurationPrecisePipe implements PipeTransform {
    transform(value: number, defaultString?: string): any {
        if (!isPresent(value)) {
            return value;
        }

        return secondsToReadablePrecise(value, defaultString);
    }
}
